import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "ion-text-wrap ion-text-center"
};
const _hoisted_2 = {
  class: "ion-padding-horizontal"
};
import { IonicSlides, modalController } from '@ionic/vue';
import { useDebounceFn } from '@vueuse/shared';
import { Pagination } from 'swiper/modules';
import { Swiper as VueSwiper, SwiperSlide } from 'swiper/vue';
import { computed, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ColumbiaSelfReportForm from '@/components/ColumbiaSelfReportForm.vue';
import usePhq9 from '@/composables/global/use-phq9';
import { errorAlert } from '@/utils/ion-alert';
import 'swiper/css';
import 'swiper/css/pagination';
const NUM_QUESTIONS = 9;
export default /*#__PURE__*/_defineComponent({
  __name: 'Phq9FormModal',
  props: {
    byGuide: {
      type: Boolean
    },
    closable: {
      type: Boolean
    },
    userId: {}
  },
  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n({
      messages: {
        en: {
          headerPrompt: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
          responses: ['Not At All', 'Several Days', 'More than Half the Days', 'Nearly Every Day'],
          prompts: ['Little interest or pleasure in doing things', 'Feeling down, depressed or hopeless', 'Trouble falling asleep, staying asleep, or sleeping too much', 'Feeling tired or having little energy', 'Poor appetite or overeating', "Feeling bad about yourself - or that you're a failure or have let yourself or your family down", 'Trouble concentrating on things, such as reading the newspaper or watching television', 'Moving or speaking so slowly that other people could have noticed. Or, the opposite - being so fidgety or restless that you have been moving around a lot more than usual', 'Thoughts that you would be better off dead or of hurting yourself in some way'],
          submitButton: 'Submit',
          skipButton: 'skip question',
          thankYou: 'Thank you for responding'
        },
        es: {
          headerPrompt: 'Durante las últimas 2 semanas, ¿con qué frecuencia le ha molestado alguno de los siguientes problemas?',
          responses: ['Nunca', 'Varios Días', 'Más de la Mitad de los Días', 'Casi Todos los Dias'],
          prompts: ['Poco interés o placer en hacer las cosas', 'Sentirse deprimido/a o sin esperanza', 'Problemas para conciliar el sueño, permanecer dormido o dormir demasiado', 'Sentirse cansado/a o tener poca energía', 'Falta de apetito o comer en exceso', 'Sentirse mal consigo mismo, o que es un fracasado/a o que se ha defraudado a sí mismo o a su familia', 'Problemas para concentrarse en cosas, como leer el periódico o mirar televisión', 'Moverse o hablar tan lentamente que otras personas podrían haberlo notado. O, al contrario, estar tan inquieto o agitado que se ha estado moviendo mucho más de lo habitual', 'Pensamientos de que estaría mejor muerto o de lastimarse a sí mismo de alguna manera'],
          submitButton: 'Enviar',
          skipButton: 'Saltar Pregunta',
          thankYou: 'Gracias por responder'
        }
      }
    });
    const {
      addPhq9Response
    } = usePhq9();
    const modules = [Pagination, IonicSlides];
    const formState = reactive({
      isSliding: false,
      isSubmitting: false,
      showThanks: false,
      ratings: []
    });
    const slidesRef = ref();
    function setSwiperInstance(swiper) {
      slidesRef.value = swiper;
    }
    const isSubmitEnabled = computed(() => {
      return formState.ratings[NUM_QUESTIONS - 1] !== undefined;
    });
    async function showColumbiaForm() {
      const columbiaForm = await modalController.create({
        id: 'columbiaForm',
        component: ColumbiaSelfReportForm,
        cssClass: 'stack-modal',
        backdropDismiss: false
      });
      columbiaForm.present();
    }
    function dismiss(submitted) {
      if (submitted) {
        formState.showThanks = true;
        setTimeout(async () => {
          // If the last question receives any non-zero response,
          // not including skip, the columbia form should be triggered
          const triggerColumbiaForm = formState.ratings[8] > 0 && formState.ratings[8] !== 99;
          await modalController.dismiss({
            submitted,
            triggerColumbiaForm
          }, undefined, 'phq9Form');
          if (triggerColumbiaForm) {
            showColumbiaForm();
          }
        }, 2000);
      } else {
        modalController.dismiss({
          submitted
        }, undefined, 'phq9Form');
      }
    }
    const debouncedSlideNext = useDebounceFn(() => {
      var _slidesRef$value;
      (_slidesRef$value = slidesRef.value) === null || _slidesRef$value === void 0 || _slidesRef$value.slideNext();
    }, 500);
    function selectRating(index, rating) {
      formState.ratings[index] = rating;
      debouncedSlideNext();
    }
    async function submitForm() {
      formState.isSubmitting = true;
      try {
        var _props$byGuide;
        await addPhq9Response({
          byGuide: (_props$byGuide = props.byGuide) !== null && _props$byGuide !== void 0 ? _props$byGuide : false,
          userId: props.userId,
          phq9Data: formState.ratings
        });
        dismiss(true);
      } catch (error) {
        errorAlert({
          error
        });
        dismiss(false);
      } finally {
        formState.isSubmitting = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_ion_title = _resolveComponent("ion-title");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_buttons = _resolveComponent("ion-buttons");
      const _component_ion_toolbar = _resolveComponent("ion-toolbar");
      const _component_ion_header = _resolveComponent("ion-header");
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_radio = _resolveComponent("ion-radio");
      const _component_ion_item = _resolveComponent("ion-item");
      const _component_ion_radio_group = _resolveComponent("ion-radio-group");
      const _component_ion_list = _resolveComponent("ion-list");
      const _component_ion_spinner = _resolveComponent("ion-spinner");
      const _component_ion_content = _resolveComponent("ion-content");
      const _component_ion_footer = _resolveComponent("ion-footer");
      const _component_ion_page = _resolveComponent("ion-page");
      return _openBlock(), _createBlock(_component_ion_page, null, {
        default: _withCtx(() => [_createVNode(_component_ion_header, null, {
          default: _withCtx(() => [_createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [!formState.showThanks ? (_openBlock(), _createBlock(_component_ion_title, {
              key: 0,
              class: "ion-padding modal-title",
              color: "toolbar-text"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('headerPrompt')), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.closable ? (_openBlock(), _createBlock(_component_ion_buttons, {
              key: 1,
              slot: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_button, {
                onClick: _cache[0] || (_cache[0] = $event => dismiss(false))
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_icon, {
                  slot: "icon-only",
                  icon: "close"
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [formState.showThanks ? (_openBlock(), _createBlock(_component_ion_label, {
            key: 0,
            class: "ion-padding ion-text-center slide-thank-you-text"
          }, {
            default: _withCtx(() => [_createElementVNode("h1", null, _toDisplayString(_unref(t)('thankYou')), 1), _createVNode(_component_ion_icon, {
              name: "checkmark",
              size: "large",
              color: "primary"
            })]),
            _: 1
          })) : (_openBlock(), _createBlock(_unref(VueSwiper), {
            key: 1,
            onSwiper: setSwiperInstance,
            modules: modules,
            pagination: "",
            class: "swiper-no-swiping swiper-slides"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8], questionIndex => {
              return _createVNode(_unref(SwiperSlide), {
                key: questionIndex,
                class: "swiper-slide"
              }, {
                default: _withCtx(() => [_createVNode(_component_ion_list, {
                  class: "swiper-slide-content"
                }, {
                  default: _withCtx(() => [_createElementVNode("h4", _hoisted_2, [_createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`prompts[${questionIndex}]`)), 1)]),
                    _: 2
                  }, 1024)]), _createVNode(_component_ion_radio_group, {
                    value: formState.ratings[questionIndex]
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], responseIndex => {
                      return _createVNode(_component_ion_item, {
                        key: responseIndex,
                        disabled: formState.isSliding || formState.isSubmitting,
                        onClick: $event => selectRating(questionIndex, responseIndex)
                      }, {
                        default: _withCtx(() => [_createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)(`responses[${responseIndex}]`)), 1)]),
                          _: 2
                        }, 1024), _createVNode(_component_ion_radio, {
                          slot: "start",
                          value: responseIndex
                        }, null, 8, ["value"])]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]);
                    }), 64))]),
                    _: 2
                  }, 1032, ["value"])]),
                  _: 2
                }, 1024), _createVNode(_component_ion_button, {
                  class: "block-centered",
                  onClick: $event => selectRating(questionIndex, 99),
                  fill: "clear",
                  size: "small"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('skipButton')), 1)]),
                  _: 2
                }, 1032, ["onClick"]), !isSubmitEnabled.value ? (_openBlock(), _createBlock(_component_ion_label, {
                  key: 0,
                  class: "slide-foot-note ion-padding"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(`${questionIndex + 1} / 9`), 1)]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), isSubmitEnabled.value ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 1,
                  disabled: formState.isSubmitting,
                  onClick: submitForm,
                  expand: "block",
                  class: "ion-margin-top"
                }, {
                  default: _withCtx(() => [formState.isSubmitting ? (_openBlock(), _createBlock(_component_ion_spinner, {
                    key: 0
                  })) : (_openBlock(), _createBlock(_component_ion_label, {
                    key: 1
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('submitButton')), 1)]),
                    _: 1
                  }))]),
                  _: 1
                }, 8, ["disabled"])) : _createCommentVNode("", true)]),
                _: 2
              }, 1024);
            }), 64))]),
            _: 1
          }))]),
          _: 1
        }), _createVNode(_component_ion_footer, null, {
          default: _withCtx(() => {
            var _slidesRef$value2;
            return [((_slidesRef$value2 = slidesRef.value) === null || _slidesRef$value2 === void 0 ? void 0 : _slidesRef$value2.activeIndex) !== 0 && !formState.showThanks ? (_openBlock(), _createBlock(_component_ion_item, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = $event => {
                var _slidesRef$value3;
                return (_slidesRef$value3 = slidesRef.value) === null || _slidesRef$value3 === void 0 ? void 0 : _slidesRef$value3.slidePrev();
              }),
              lines: "none"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_icon, {
                class: "icon",
                size: "large",
                icon: "arrow-back"
              })]),
              _: 1
            })) : _createCommentVNode("", true)];
          }),
          _: 1
        })]),
        _: 1
      });
    };
  }
});